"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _theme = _interopRequireDefault(require("../../../theme"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var Down = function Down() {
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("path", {
    fill: _theme["default"].scaleLevel20,
    d: "M1.328 23.59C1.026 21.452.098 19.103.02 16.683c-.076-2.337.048-4.764.718-6.98.692-2.288 2.05-4.47 4.11-6.223C7.554 1.174 11.003.332 14.097.073c5.062-.424 9.527 1.13 10.124 1.304 2.982.867 6.123 1.881 8.407 3.715 2.19 1.757 3.53 4.181 4.783 6.545 1.196 2.257 2.502 4.686 2.584 7.251.087 2.69-1.436 4.97-2.44 7.056-1.207 2.512-2.66 4.652-4.485 6.304-3.085 2.793-6.227 4.41-7.033 4.805-.4.196-4.234 1.953-8.706 2.677-3.036.492-6.227.388-8.984-.953-2.907-1.414-5.056-3.767-6.069-6.77-.885-2.623-.563-5.67-.951-8.416Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: _theme["default"].scaleLevel100,
    d: "M26.74 19.38a.881.881 0 0 0-1.24 0l-4.63 4.63V13.88c0-.48-.39-.88-.88-.88s-.88.39-.88.88v10.14l-4.63-4.63a.881.881 0 0 0-1.24 0c-.34.34-.34.9 0 1.24l6.12 6.12c.08.08.18.14.28.19.1.04.22.06.33.07h.02c.11 0 .22-.02.33-.07.11-.04.2-.11.28-.19l6.12-6.12c.34-.34.34-.9 0-1.24l.02-.01Z"
  }));
};
var _default = exports["default"] = Down;